const Table = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", ry: "2" }],
    ["line", { x1: "3", y1: "9", x2: "21", y2: "9" }],
    ["line", { x1: "3", y1: "15", x2: "21", y2: "15" }],
    ["line", { x1: "12", y1: "3", x2: "12", y2: "21" }]
  ]
];

export default Table;
